export default {
  URLS: {
	EMPLOYEE: '/kiosk/employees/',
	ACTIVATE: '/kiosk/employees/activate/',
	COMPANY: '/kiosk/employees/company_settings/',
  },
};

